export default __webpack_public_path__ + "static/media/image6.df53cba2.png";